import { CHANGE_TRUE, CHANGE_FALSE } from './types';

const changeData = () => {
    return {
        type: CHANGE_TRUE
    }
}
const unchangeData = () => {
    return {
        type: CHANGE_FALSE
    }
}

export { changeData, unchangeData };